import { IDriverRow } from "../../components/views/NewBooking/PersonalDetails/CustomerView/AddNewDriver";

export const ADD_NEW_DRIVERS = "ADD_NEW_DRIVERS";

interface IAddNewDrivers {
	payload: IDriverRow[];
	type: typeof ADD_NEW_DRIVERS; 
}

export type DriverAction = IAddNewDrivers